import { CONTENT_TYPES } from '../../../constants/suggestions'

/**
 * Öneri verilerini doğrular
 * @param {Object} suggestionData - Doğrulanacak öneri verileri
 * @param {boolean} isUpdate - Güncelleme işlemi mi (true) yoksa yeni oluşturma işlemi mi (false)
 * @returns {Object} { isValid, errors } - Doğrulama sonucu ve hata mesajları
 */
export const validateSuggestion = (suggestionData, isUpdate = false) => {
  const errors = {}

  // Oluşturma sırasında zorunlu alanları kontrol et
  // Güncelleme işleminde bu alanlar backend'e gönderilmediği için kontrol etme
  if (!isUpdate) {
    if (suggestionData.contentId === undefined || suggestionData.contentId === null) {
      errors.contentId = 'İçerik ID zorunludur'
    } else {
      // contentId'yi string'e çevir
      suggestionData.contentId = String(suggestionData.contentId)
    }

    if (!suggestionData.contentType) {
      errors.contentType = 'İçerik tipi zorunludur'
    } else if (!Object.values(CONTENT_TYPES).includes(suggestionData.contentType)) {
      errors.contentType = 'Geçersiz içerik tipi'
    }

    if (!suggestionData.contentCategory) {
      errors.contentCategory = 'İçerik kategorisi zorunludur'
    }
  }

  // Her zaman kontrol edilmesi gereken alanlar
  if (!suggestionData.suggestion) {
    errors.suggestion = 'Öneri metni zorunludur'
  }

  // İçerik tipine özel doğrulamalar - Sadece ilgili alan doluysa kontrol et
  if (suggestionData.currentImageUrl) {
    // URL doğrulaması - basitleştirilmiş, çoğu URL'yi kabul eden versiyon
    if (!isValidUrl(suggestionData.currentImageUrl)) {
      errors.currentImageUrl = 'Geçerli bir görsel URL\'i giriniz'
    }
  }

  if (suggestionData.currentVideoUrl) {
    // URL doğrulaması - basitleştirilmiş, çoğu URL'yi kabul eden versiyon
    if (!isValidUrl(suggestionData.currentVideoUrl)) {
      errors.currentVideoUrl = 'Geçerli bir video URL\'i giriniz'
    }
  }

  // Öncelik kontrolü (opsiyonel alan)
  if (suggestionData.priority !== undefined) {
    const priority = parseInt(suggestionData.priority)
    if (isNaN(priority) || priority < 1 || priority > 5) {
      errors.priority = 'Öncelik 1-5 arası bir değer olmalıdır'
    }
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  }
}

/**
 * URL biçiminin geçerli olup olmadığını kontrol eder
 * @param {string} url - Kontrol edilecek URL
 * @returns {boolean} - URL geçerli ise true, değilse false
 */
function isValidUrl(url) {
  try {
    new URL(url)
    return true
  } catch (e) {
    // HTTP protokolü eksik olabilir, eklemeyi dene
    try {
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        new URL('https://' + url)
        return true
      }
      return false
    } catch (e) {
      return false
    }
  }
}
